/**
 * The Data Room export: a browser navigation, not a fetch, so the client
 * owns only the address.
 */

/** The browser navigates here to download; not a fetch, so no function. */
export const DATA_ROOM_EXPORT_URL = '/workspace/data-room/export';
